<template>
  <a-modal v-model="visible" width="1100px" :mask-closable="false" title="新建货品" :footer="null" centered @cancel="onhidden">
    <div class="chooseGoods"></div>
    <a-form-model ref="addGoodsModel" :model="form" :rules="rules" layout="inline">
      <a-form-model-item
        ref="skuName"
        v-bind="colWidth"
        label="货品名称"
        prop="skuName"
      >
        <a-input v-model="form.skuName" placeholder="请输入,最多30个字符" />
      </a-form-model-item>
      <a-form-model-item
        ref="skuCode"
        v-bind="colWidth"
        label="货主货品编码"
        prop="skuCode"
      >
        <a-input v-model="form.skuCode" placeholder="请输入,最多30个字符，不填写系统将自动生成" />
      </a-form-model-item>
      <a-form-model-item
        ref="norms"
        v-bind="colWidth"
        label="货品基础规格"
        prop="norms"
      >
        <a-input v-model="form.norms" placeholder="请输入,最多20个字符" />
      </a-form-model-item>
      <a-form-model-item
        ref="unit"
        v-bind="colWidth"
        label="货品计量整单位"
        prop="unit"
      >
        <a-input v-model="form.unit" placeholder="箱、袋、个、件等，不填写默认为件" />
      </a-form-model-item>
      <a-form-model-item
        ref="weight"
        v-bind="colWidth"
        label="整单位重量"
        prop="weight"
      >
        <InputNumber v-model="form.weight" suffix="kg" :max="999999.999" placeholder="请输入，仅支持数字" />
      </a-form-model-item>
      <a-form-model-item
        ref="volume"
        v-bind="colWidth"
        label="货品体积"
        prop="volume"
      >
        <InputNumber v-model="form.volume" suffix="M³" :max="999999.999" placeholder="请输入，仅支持数字" />
      </a-form-model-item>
      <a-form-model-item
        ref="temperatureZone"
        v-bind="colWidth"
        label="温区"
        prop="temperatureZone"
      >
        <a-radio-group v-model="form.temperatureZone" name="radioGroup">
          <a-radio v-for="(temp, i) in TEMPERATURES" :key="i" :value="temp.value">{{temp.label}}</a-radio>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item
        ref="goodsPrice"
        v-bind="colWidth"
        label="货品单件含税价(元)"
        prop="goodsPrice"
      >
        <InputNumber
          v-model="form.goodsPrice"
          suffix="元"
          :precision="2"
          :max="999999999.99"
          placeholder="请输入，仅支持数字"
        />
      </a-form-model-item>
    </a-form-model>

    <a-row class="btnBox">
      <a-col :span="8" :offset="16">
        <a-button class="goodsSelectStyle" @click="onhidden">取消</a-button>
        <a-button v-track-click="{ trackName: '新建货品-提交' }" class="goodsSelectStyle" type="primary" @click="onUpdate">提交</a-button>
        <a-button v-track-click="{ trackName: '新建货品-提交并继续新建' }" class="goodsSelectStyle" type="primary" @click="onContinue">提交并继续新建</a-button>
      </a-col>
    </a-row>
  </a-modal>
</template>

<script>
import InputNumber from "@/components/form/InputNumber.vue";
import { createSku } from "../api";

const TEMPERATURES = [
  {
    value: "常温",
    label: "常温",
  },
  {
    value: "冷藏",
    label: "冷藏（0°C〜6°C）",
  },
  {
    value: "冷冻",
    label: "冷冻（-18°C以下）",
  },
];
export default {
  name: "AddGoods",
  components: {
    InputNumber,
  },
  props: {},
  data() {
    return {
      visible: false,
      colWidth:{
        labelCol: {span: 4},
        wrapperCol: {span: 20}
      },
      form: {
        skuCode: "",
        skuName: "",
        norms: "",
        unit: "",
        weight: "",
        volume: "",
        goodsPrice: "",
        temperatureZone: "常温",
      },
      rules: {
        skuCode: [{ max: 30, message: "长度不超过30字符", trigger: "change" }],
        skuName: [
          { required: true, message: "请输入货品名称", trigger: "change" },
          { max: 30, message: "长度不超过30字符", trigger: "change" },
        ],
        norms: [
          { required: true, message: "请输入规格", trigger: "change" },
          { max: 30, message: "长度不超过30字符", trigger: "change" },
        ],
        unit: [{ max: 4, message: "长度不超过4字符", trigger: "change" }],
        weight: [
          { required: true, message: "请输入单件重量", trigger: "change" },
        ],
        volume: [
          { required: true, message: "请输入单件体积", trigger: "change" },
        ],
        temperatureZone: [
          { required: true, message: "请选择温区", trigger: "change" },
        ],
      },
      TEMPERATURES,
    };
  },
  computed: {},
  created() {},
  mounted() {},
  methods: {
    onhidden() {
      this.visible = false;
      this.$emit('create')
    },
    show() {
      this.visible = true;
      this.form = {
        skuCode: "",
        skuName: "",
        norms: "",
        unit: "",
        weight: "",
        volume: "",
        goodsPrice: "",
        temperatureZone: "常温",
      };
    },
    async onUpdate() {
      await this.$refs.addGoodsModel.validate();
      await createSku(this.form);
      this.$message.success("操作成功");
      this.onhidden()
    },
    async onContinue() {
      await this.$refs.addGoodsModel.validate();
      await createSku(this.form);
      this.$message.success("操作成功");
      this.show()
    },
  },
};
</script>

<style lang="less" scoped>
/deep/ .ant-form-item {
  width: calc(50% - 16px);
  margin-bottom: 24px;
}
/deep/ .ant-form-explain {
  position: absolute;
}
.btnBox {
  padding-right: 16px;
  text-align: right;
  button {
    margin-left: 15px;
  }
}
</style>